"use client";

import { createContext, useContext, ReactNode, useState } from "react";
import { useSearchParams } from "next/navigation";
import { ORDER_OPTIONS } from "@/app/(store)/_components/order-dropdown/order-options";

type FiltersProviderProps = {
  children: ReactNode;
};

type FiltersContextType = {
  isFiltering: boolean;
  setIsFiltering: (loading: boolean) => void;
  searchTerm: string;
  setSearchTerm: (term: string) => void;
  categoryId: string | null;
  setCategoryId: (id: string | null) => void;
  order: string | null;
  setOrder: (order: string | null) => void;
};

const FiltersContext = createContext<FiltersContextType | undefined>(undefined);

export const FiltersProvider = ({ children }: FiltersProviderProps) => {
  const searchParams = useSearchParams();

  const [isFiltering, setIsFiltering] = useState(false);
  const [searchTerm, setSearchTerm] = useState(
    () => searchParams.get("busca") || ""
  );
  const [categoryId, setCategoryId] = useState<string | null>(
    () => searchParams.get("categoria") || null
  );
  const [order, setOrder] = useState<string | null>(
    () =>
      ORDER_OPTIONS.find(
        (option) => option.value === searchParams.get("ordenar")
      )?.value || null
  );

  const value: FiltersContextType = {
    isFiltering,
    setIsFiltering,
    searchTerm,
    setSearchTerm,
    categoryId,
    setCategoryId,
    order,
    setOrder,
  };

  return (
    <FiltersContext.Provider value={value}>{children}</FiltersContext.Provider>
  );
};

export const useFilters = (): FiltersContextType => {
  const context = useContext(FiltersContext);

  if (!context) {
    throw new Error("useFilters must be used within a FiltersProvider");
  }

  return context;
};
